var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Colour",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33341 0.833252H13.3334V2.49992H3.33341V14.1666H1.66675V2.49992C1.66675 1.58325 2.41675 0.833252 3.33341 0.833252ZM17.5001 9.16658L12.5001 4.16658H6.66675C5.75008 4.16658 5.00841 4.91658 5.00841 5.83325L5.00008 17.4999C5.00008 18.4166 5.74175 19.1666 6.65841 19.1666H15.8334C16.7501 19.1666 17.5001 18.4166 17.5001 17.4999V9.16658ZM16.2501 9.99992H11.6667V5.41658L16.2501 9.99992Z",
    fill: "#3A4861"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.5a7daedae9a0348117faf6ae2d339091.svg";
export { ForwardRef as ReactComponent };